import { useMemo } from "react";

/*
Groups assets-related state and derived data into memoized containers for presentation components.
This hook assumes the caller manages fetching and state.
*/
export const useAssetsData = ({
  values = {},
  set = {},
  tables = {},
  flags = {},
  handlers = {},
  lists = {},
}) => {
  const memoValues = useMemo(
    () => ({ ...values }),
    [
      values.solarCapacity,
      values.batteryCapacity,
      values.batteryEnergyCapacity,
      values.gensetCapacity,
      values.edgeId,
      values.hasLoad,
    ],
  );

  const memoSetters = useMemo(() => ({ ...set }), [set]);
  const memoTables = useMemo(() => ({ ...tables }), [tables]);
  const memoFlags = useMemo(() => ({ ...flags }), [flags]);
  const memoHandlers = useMemo(() => ({ ...handlers }), [handlers]);
  const memoLists = useMemo(() => ({ ...lists }), [lists]);

  return useMemo(
    () => ({
      assets: { ...memoValues, ...memoSetters },
      tables: memoTables,
      flags: memoFlags,
      handlers: memoHandlers,
      lists: memoLists,
    }),
    [memoValues, memoSetters, memoTables, memoFlags, memoHandlers, memoLists],
  );
};

export default useAssetsData;
